module.exports = __webpack_public_path__ + "static/media/Milk-TeaAtdusk.db9237ef.jpg";